// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-detail-layout {
  min-height: 100vh;
  background: var(--color-bg);
}

.app-detail-content {
  padding: 24px 0;
  min-height: calc(100vh - 200px);
}

.content-container.app-detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 游戏信息区域 */
.game-info-section {
  margin-bottom: 40px;
}

.game-info-card {
  background: var(--color-bg-white);
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* 游戏标题单独区域 */
.game-title-section {
  padding: 24px 32px 16px 32px;
  border-bottom: 1px solid #f0f0f0;
}

.game-title-section .game-title {
  margin: 0 !important;
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.2;
}

.title-with-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.title-actions {
  display: flex;
  align-items: center;
}

.home-button {
  color: var(--color-primary);
  font-weight: 500;
  transition: all 0.3s ease;
}

.home-button:hover {
  color: var(--color-primary-hover);
  background-color: var(--color-primary-light);
}

.game-info-row {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 24px;
  padding: 16px 32px 24px 32px; /* 调整padding，顶部减少因为标题已移出 */
  border-bottom: 1px solid #f0f0f0;
}

.game-logo-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.game-logo {
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.game-info-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}

.game-info-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
}



.game-developer {
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--color-text-secondary);
}

.developer-label {
  color: var(--color-text-tertiary);
  margin-right: 4px;
  font-weight: 800;
}

.developer-name {
  color: var(--color-text-secondary);
  font-weight: 500;
}

.game-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag-category {
  background: rgba(108, 92, 231, 0.1);
  color: var(--color-primary);
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 9999px;
  font-weight: 500;
}

.game-rating-info {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.rating-badge {
  background: rgba(108, 92, 231, 0.1);
  color: var(--color-primary);
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.game-rating {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.rating-stars .ant-rate {
  color: #faad14 !important;
  font-size: 16px !important;
}

.rating-score {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text);
}



.game-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.game-info-right {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn-rating {
  background: #faad14 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 9999px !important;
  font-weight: 500;
  padding: 4px 16px !important;
  height: auto !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  transition: all 0.3s ease !important;
  font-size: 14px;
}

.btn-rating:hover {
  background: #ffc53d !important;
  color: #2d3436 !important;
}

.btn-share {
  background: #f5f5f5 !important;
  color: #2d3436 !important;
  border: none !important;
  border-radius: 9999px !important;
  font-weight: 500;
  padding: 4px 16px !important;
  height: auto !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  transition: all 0.3s ease !important;
  font-size: 14px;
}

.btn-share:hover {
  background: #e5e5e5 !important;
  color: #2d3436 !important;
}

.btn-download {
  height: 48px !important;
  padding: 0 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  border-radius: 9999px !important;
  border: none !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px;
}

.btn-download:hover {
  transform: translateY(-1px);
}

.btn-android {
  background: #16a34a !important;
  color: white !important;
}

.btn-android:hover {
  background: #15803d !important;
  color: white !important;
}

.btn-ios {
  background: #1f2937 !important;
  color: white !important;
}

.btn-ios:hover {
  background: #000000 !important;
  color: white !important;
}

.btn-primary {
  background: linear-gradient(135deg, #6C5CE7 0%, #5f4dd0 100%) !important;
  color: white !important;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5f4dd0 0%, #5240b9 100%) !important;
  color: white !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(108, 92, 231, 0.3) !important;
}

/* 禁用状态的下载按钮样式 */
.btn-download.btn-disabled {
  background: #f5f5f5 !important;
  color: #bfbfbf !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

.btn-download.btn-disabled:hover {
  background: #f5f5f5 !important;
  color: #bfbfbf !important;
  transform: none !important;
}

/* 游戏描述区域 */
.game-description-section {
  padding: 24px;
}

.description-title {
  margin: 0 0 24px 0 !important;
  color: var(--color-text);
  font-weight: 700;
  font-size: 18px;
  display: inline-flex; /* 改为inline-flex，让容器宽度适应内容 */
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 2px solid #6C5CE7; /* 横线只在icon+文字宽度下方 */
}

.description-icon {
  color: var(--color-primary);
  font-size: 16px; /* 与section-icon保持一致 */
  /* 移除margin-top，让flex的align-items: center处理垂直居中 */
}

/* 游戏截图样式 */
.game-screenshots {
  margin: 20px 0;
}

.screenshots-container {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 8px 0;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

.screenshots-container::-webkit-scrollbar {
  height: 6px;
}

.screenshots-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.screenshots-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.screenshots-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.screenshot-item {
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  position: relative;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screenshot-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.screenshot-image {
  width: 200px;
  height: 120px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

.screenshot-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 120px;
  background: #f5f5f5;
  border-radius: 8px;
}

.screenshots-hint {
  text-align: center;
  margin-top: 12px;
  color: #666;
  font-size: 12px;
  font-style: italic;
}

.screenshots-hint span {
  background: rgba(108, 92, 231, 0.1);
  color: var(--color-primary);
  padding: 4px 12px;
  border-radius: 12px;
  display: inline-block;
}

.no-screenshots {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
}

.no-screenshots span {
  display: inline-block;
  padding: 8px 16px;
  background: #f0f0f0;
  border-radius: 20px;
  color: #666;
}

.description-content {
  line-height: 1.6;
  color: #6b7280;
}

.description-content p {
  margin-bottom: 12px;
}

.description-stats {
  margin-top: 12px !important;
  color: #6b7280;
}

.description-content h1,
.description-content h2,
.description-content h3,
.description-content h4,
.description-content h5,
.description-content h6 {
  color: var(--color-text);
  margin-top: 24px;
  margin-bottom: 12px;
}

/* h5标签特定样式 */
.description-content h5 {
  font-size: 16px;
  font-weight: 600;
}

.description-content p {
  margin-bottom: 12px;
}

.description-content ul,
.description-content ol {
  margin-bottom: 12px;
  padding-left: 24px;
}

.description-content li {
  margin-bottom: 4px;
}

.description-content strong {
  color: var(--color-text);
  font-weight: 600;
}

.description-content code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

/* 更多游戏区域 */
.more-games-section {
  background: var(--color-bg-white);
  border-radius: var(--border-radius-lg);
  padding: 32px;
  box-shadow: var(--shadow-sm);
  margin-bottom: 32px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  margin: 0 !important;
  color: var(--color-text);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
}

.section-icon {
  color: var(--color-primary);
  font-size: 16px;
  margin-right: 8px;
}

.section-more {
  color: var(--color-primary);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: var(--transition);
}

.section-more:hover {
  color: var(--color-secondary);
  transform: translateX(2px);
}

.games-grid {
  margin-bottom: 24px;
}

.game-card {
  background: var(--color-bg-white);
  border-radius: var(--border-radius);
  border: 1px solid #f0f0f0;
  overflow: hidden;
  cursor: pointer;
  transition: var(--transition);
  height: 100%;
}

.game-card-hover:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: rgba(108, 92, 231, 0.2);
}

.game-card-image {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
}

.game-card-img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
}

.game-card-info {
  padding: 0 12px 12px 12px;
}

.game-card-title {
  margin: 0 0 8px 0 !important;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text);
  line-height: 1.3;
}

.game-card-rating {
  display: flex;
  align-items: center;
  gap: 4px;
}

.game-card-rating .ant-rate {
  font-size: 10px !important;
  color: #faad14 !important;
}

.rating-text {
  font-size: 11px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.random-play-section {
  text-align: center;
  padding-top: 24px;
}

.btn-random-play {
  background: var(--color-primary) !important;
  border: none !important;
  border-radius: 9999px !important;
  height: 48px !important;
  padding: 0 32px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: white !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px;
}

.btn-random-play:hover {
  background: rgba(108, 92, 231, 0.9) !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

/* 评分弹窗样式 */
.rating-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.rating-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.rating-modal-header .close-btn {
  border: none;
  box-shadow: none;
  color: #999;
}

.rating-modal-header .close-btn:hover {
  color: #666;
}

.rating-modal-content {
  text-align: center;
}

.game-info-modal {
  margin-bottom: 24px;
}

.game-logo-modal {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 16px;
}

.game-title-modal {
  margin: 0 !important;
  font-size: 16px;
  font-weight: 600;
}

.rating-stars-modal {
  margin-bottom: 24px;
}

.rating-stars-large .ant-rate {
  font-size: 32px !important;
  color: #faad14 !important;
}

.review-input {
  margin-bottom: 24px;
}

.review-input .ant-input {
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  resize: none;
}

.review-input .ant-input:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
}

.submit-rating-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  font-weight: 500;
  background: var(--color-primary) !important;
  border: none !important;
}

.submit-rating-btn:hover {
  background: rgba(108, 92, 231, 0.9) !important;
}

.submit-rating-btn:disabled {
  background: #f5f5f5 !important;
  color: #bfbfbf !important;
}

/* 分享弹窗样式 */
.share-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.share-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.share-modal-header .close-btn {
  border: none;
  box-shadow: none;
  color: #999;
}

.share-modal-header .close-btn:hover {
  color: #666;
}

.share-modal-content {
  text-align: center;
  padding: 8px;
  min-width: 200px;
}

.share-description {
  margin-bottom: 24px;
  color: #666;
  font-size: 14px;
}

.share-platforms {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.share-platform {
  cursor: pointer;
  transition: all 0.3s ease;
}

.share-platform:hover {
  transform: scale(1.1);
}

.share-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  transition: all 0.3s ease;
}

.share-icon.weibo {
  background: #E6162D;
}

.share-icon.qq {
  background: #12B7F5;
}

.share-icon.wechat {
  background: #0F88EB;
}

.share-icon.zhihu {
  background: #0066FF;
}

.share-icon.twitter {
  background: #1DA1F2;
}

.share-icon.facebook {
  background: #4267B2;
}

.share-icon.youtube {
  background: #FF0000;
}

.share-icon.link {
  background: #f5f5f5;
  color: #666;
}

.share-link-section {
  display: flex;
  gap: 8px;
  align-items: center;
}

.share-link-input {
  flex: 1 1;
  border-radius: 8px;
}

.copy-link-btn {
  border-radius: 8px;
  background: var(--color-primary) !important;
  border: none !important;
}

.copy-link-btn:hover {
  background: rgba(108, 92, 231, 0.9) !important;
}

.sidebar {
  position: sticky;
  top: 88px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sidebar-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sidebar-card .ant-card-head-title {
  font-size: 16px;
  font-weight: 600;
}

.categories-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.category-item {
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s ease;
  margin: 0;
}

.category-item:hover {
  background: #1890ff;
  color: #fff;
  transform: translateY(-1px);
}

.sidebar-app-item {
  cursor: pointer;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin: 0 -8px;
  padding: 12px 8px;
}

.sidebar-app-item:last-child {
  border-bottom: none;
}

.sidebar-app-item:hover {
  background: #f9f9f9;
  transform: translateX(4px);
}

.sidebar-app-name {
  color: #262626;
  font-weight: 500;
  font-size: 14px;
}

.sidebar-app-category {
  font-size: 12px;
}

@media (max-width: 992px) {
  .sidebar {
    position: static;
    margin-top: 24px;
  }
  
  .sidebar-card {
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  /* 修复移动端滚动问题 - 覆盖全局的overflow设置 */
  body {
    overflow: auto !important; /* 允许页面滚动 */
  }

  .App {
    height: auto !important; /* 移除固定高度 */
    overflow: auto !important; /* 允许滚动 */
  }

  .app-detail-layout {
    min-height: auto; /* 移除固定高度限制 */
    height: auto; /* 确保高度自适应内容 */
  }

  .app-detail-content {
    min-height: auto; /* 移除固定高度限制 */
    padding: 16px 0; /* 减少padding */
  }

  .content-container.app-detail-container {
    padding: 0 16px;
  }

  .game-info-row {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 20px;
  }

  .game-info-content {
    grid-template-columns: 1fr;
    gap: 20px;
    text-align: center;
  }

  .game-logo {
    width: 120px;
    height: 120px;
  }

  .game-title-section {
    padding: 20px 20px 12px 20px;
  }

  .game-title-section .game-title {
    font-size: 20px;
  }

  .game-tags {
    justify-content: center;
  }

  .game-rating-info {
    justify-content: center;
  }

  .game-rating {
    justify-content: center;
  }

  .game-actions {
    justify-content: center;
  }

  .game-info-right {
    align-items: center;
  }

  .btn-download {
    min-width: 140px;
  }

  .more-games-section {
    padding: 20px;
  }

  .section-title {
    font-size: 16px;
  }

  .description-title {
    font-size: 16px; /* 移动端字号调整 */
  }

  .game-screenshots {
    margin: 16px 0;
  }

  .screenshots-container {
    gap: 8px;
    padding: 4px 0;
  }

  .screenshot-image {
    width: 160px;
    height: 96px;
  }

  .screenshot-loading {
    width: 160px;
    height: 96px;
  }

  .screenshots-hint {
    margin-top: 8px;
    font-size: 11px;
  }

  .screenshots-hint span {
    padding: 3px 8px;
  }

  .no-screenshots {
    padding: 30px 16px;
    margin: 16px 0;
  }

  .no-screenshots span {
    padding: 6px 12px;
    font-size: 13px;
  }

  .game-card-title {
    font-size: 12px;
  }

  .btn-random-play {
    height: 44px !important;
    font-size: 14px !important;
    padding: 0 24px !important;
  }

  .share-platforms {
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }

  .share-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  /* 移动端截图预览Modal样式 */
  .screenshot-preview-modal {
    margin: 16px;
    width: calc(100% - 32px) !important;
    max-width: none !important;
  }

  .screenshot-preview-image-container {
    min-height: 300px;
  }

  .screenshot-preview-header {
    top: 12px;
    right: 12px;
  }

  .screenshot-close-btn {
    width: 36px !important;
    height: 36px !important;
  }

  .screenshot-navigation {
    bottom: 16px;
    gap: 12px;
    padding: 6px 12px;
  }

  .screenshot-nav-btn {
    width: 32px !important;
    height: 32px !important;
  }

  .screenshot-counter {
    font-size: 12px;
    min-width: 36px;
  }
}

@media (max-width: 480px) {
  /* 修复移动端滚动问题 - 覆盖全局的overflow设置 */
  body {
    overflow: auto !important; /* 允许页面滚动 */
  }

  .App {
    height: auto !important; /* 移除固定高度 */
    overflow: auto !important; /* 允许滚动 */
  }

  .app-detail-layout {
    min-height: auto; /* 移除固定高度限制 */
    height: auto; /* 确保高度自适应内容 */
  }

  .app-detail-content {
    min-height: auto; /* 移除固定高度限制 */
    padding: 12px 0; /* 进一步减少padding */
  }

  .content-container.app-detail-container {
    padding: 0 12px;
  }

  .game-info-row {
    padding: 16px;
  }

  .game-logo {
    width: 100px;
    height: 100px;
  }

  .game-title-section {
    padding: 16px 16px 10px 16px;
  }

  .game-title-section .game-title {
    font-size: 18px;
  }

  .game-screenshots {
    margin: 12px 0;
  }

  .screenshots-container {
    gap: 6px;
  }

  .screenshot-image {
    width: 140px;
    height: 84px;
  }

  .screenshot-loading {
    width: 140px;
    height: 84px;
  }

  .screenshots-hint {
    margin-top: 6px;
    font-size: 10px;
  }

  .screenshots-hint span {
    padding: 2px 6px;
  }

  .no-screenshots {
    padding: 24px 12px;
    margin: 12px 0;
  }

  .no-screenshots span {
    padding: 4px 8px;
    font-size: 12px;
  }

  .game-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .btn-rating,
  .btn-share {
    width: 100%;
    justify-content: center;
  }

  .game-info-right {
    gap: 8px;
  }

  .btn-download {
    width: 100%;
    min-width: auto;
  }

  .more-games-section {
    padding: 16px;
  }

  .game-card-title {
    font-size: 11px;
  }

  .share-platforms {
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  .share-icon {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  /* 小屏幕截图预览Modal样式 */
  .screenshot-preview-modal {
    margin: 8px;
    width: calc(100% - 16px) !important;
    max-width: none !important;
  }

  .screenshot-preview-image-container {
    min-height: 200px;
  }

  .screenshot-preview-header {
    top: 6px;
    right: 6px;
  }

  .screenshot-close-btn {
    width: 28px !important;
    height: 28px !important;
  }

  .screenshot-navigation {
    bottom: 12px;
    gap: 8px;
    padding: 4px 8px;
  }

  .screenshot-nav-btn {
    width: 28px !important;
    height: 28px !important;
  }

  .screenshot-counter {
    font-size: 11px;
    min-width: 32px;
  }
}

/* 截图预览Modal样式 */
.screenshot-preview-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
  padding: 0;
}

.screenshot-preview-content {
  position: relative;
}

.screenshot-preview-header {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.screenshot-close-btn {
  background: rgba(0, 0, 0, 0.6) !important;
  color: white !important;
  border: none !important;
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s ease !important;
}

.screenshot-close-btn:hover {
  background: rgba(0, 0, 0, 0.8) !important;
  transform: scale(1.1);
}

.screenshot-preview-image-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  min-height: 400px;
}

.screenshot-navigation {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  padding: 8px 16px;
  border-radius: 20px;
}

.screenshot-nav-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border: none !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s ease !important;
}

.screenshot-nav-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: scale(1.1);
}

.screenshot-nav-btn:disabled {
  background: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 0.5) !important;
  cursor: not-allowed !important;
}

.screenshot-nav-btn:disabled:hover {
  transform: none !important;
}

.screenshot-counter {
  color: white;
  font-size: 14px;
  font-weight: 500;
  min-width: 40px;
  text-align: center;
}

.screenshot-preview-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  max-height: 80vh;
  object-fit: contain;
}

.screenshot-preview-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999;
  font-size: 16px;
  background: #f5f5f5;
  border-radius: 8px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AppDetail/AppDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,4BAA4B,EAAE,0BAA0B;EACxD,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;;AAIA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;;;AAIA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,uBAAuB;EACvB,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;AACzB;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,oBAAoB,EAAE,4BAA4B;EAClD,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC,EAAE,oBAAoB;AACxD;;AAEA;EACE,2BAA2B;EAC3B,eAAe,EAAE,sBAAsB;EACvC,iDAAiD;AACnD;;AAEA,WAAW;AACX;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,qDAAqD;EACrD,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;;;EAME,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA,WAAW;AACX;EACE,iCAAiC;EACjC,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,mFAAmF;EACnF,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,2BAA2B;EAC3B,qFAAqF;AACvF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gCAAgC;EAChC;IACE,yBAAyB,EAAE,WAAW;EACxC;;EAEA;IACE,uBAAuB,EAAE,WAAW;IACpC,yBAAyB,EAAE,SAAS;EACtC;;EAEA;IACE,gBAAgB,EAAE,aAAa;IAC/B,YAAY,EAAE,cAAc;EAC9B;;EAEA;IACE,gBAAgB,EAAE,aAAa;IAC/B,eAAe,EAAE,cAAc;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe,EAAE,YAAY;EAC/B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,YAAY;IACZ,mCAAmC;IACnC,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,gCAAgC;EAChC;IACE,yBAAyB,EAAE,WAAW;EACxC;;EAEA;IACE,uBAAuB,EAAE,WAAW;IACpC,yBAAyB,EAAE,SAAS;EACtC;;EAEA;IACE,gBAAgB,EAAE,aAAa;IAC/B,YAAY,EAAE,cAAc;EAC9B;;EAEA;IACE,gBAAgB,EAAE,aAAa;IAC/B,eAAe,EAAE,iBAAiB;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,mCAAmC;IACnC,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".app-detail-layout {\n  min-height: 100vh;\n  background: var(--color-bg);\n}\n\n.app-detail-content {\n  padding: 24px 0;\n  min-height: calc(100vh - 200px);\n}\n\n.content-container.app-detail-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  width: 100%;\n}\n\n/* 游戏信息区域 */\n.game-info-section {\n  margin-bottom: 40px;\n}\n\n.game-info-card {\n  background: var(--color-bg-white);\n  border-radius: 16px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n/* 游戏标题单独区域 */\n.game-title-section {\n  padding: 24px 32px 16px 32px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.game-title-section .game-title {\n  margin: 0 !important;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--color-text);\n  line-height: 1.2;\n}\n\n.title-with-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.title-actions {\n  display: flex;\n  align-items: center;\n}\n\n.home-button {\n  color: var(--color-primary);\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.home-button:hover {\n  color: var(--color-primary-hover);\n  background-color: var(--color-primary-light);\n}\n\n.game-info-row {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  gap: 24px;\n  padding: 16px 32px 24px 32px; /* 调整padding，顶部减少因为标题已移出 */\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.game-logo-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.game-logo {\n  width: 160px;\n  height: 160px;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.game-info-content {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n}\n\n.game-info-left {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n\n\n.game-developer {\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n.developer-label {\n  color: var(--color-text-tertiary);\n  margin-right: 4px;\n  font-weight: 800;\n}\n\n.developer-name {\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.game-tags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tag-category {\n  background: rgba(108, 92, 231, 0.1);\n  color: var(--color-primary);\n  font-size: 12px;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  font-weight: 500;\n}\n\n.game-rating-info {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rating-badge {\n  background: rgba(108, 92, 231, 0.1);\n  color: var(--color-primary);\n  padding: 4px 12px;\n  border-radius: 9999px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.game-rating {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.rating-stars .ant-rate {\n  color: #faad14 !important;\n  font-size: 16px !important;\n}\n\n.rating-score {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n\n\n.game-actions {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.game-info-right {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.btn-rating {\n  background: #faad14 !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 9999px !important;\n  font-weight: 500;\n  padding: 4px 16px !important;\n  height: auto !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  transition: all 0.3s ease !important;\n  font-size: 14px;\n}\n\n.btn-rating:hover {\n  background: #ffc53d !important;\n  color: #2d3436 !important;\n}\n\n.btn-share {\n  background: #f5f5f5 !important;\n  color: #2d3436 !important;\n  border: none !important;\n  border-radius: 9999px !important;\n  font-weight: 500;\n  padding: 4px 16px !important;\n  height: auto !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  transition: all 0.3s ease !important;\n  font-size: 14px;\n}\n\n.btn-share:hover {\n  background: #e5e5e5 !important;\n  color: #2d3436 !important;\n}\n\n.btn-download {\n  height: 48px !important;\n  padding: 0 24px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  border-radius: 9999px !important;\n  border: none !important;\n  transition: all 0.3s ease !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px;\n}\n\n.btn-download:hover {\n  transform: translateY(-1px);\n}\n\n.btn-android {\n  background: #16a34a !important;\n  color: white !important;\n}\n\n.btn-android:hover {\n  background: #15803d !important;\n  color: white !important;\n}\n\n.btn-ios {\n  background: #1f2937 !important;\n  color: white !important;\n}\n\n.btn-ios:hover {\n  background: #000000 !important;\n  color: white !important;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #6C5CE7 0%, #5f4dd0 100%) !important;\n  color: white !important;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #5f4dd0 0%, #5240b9 100%) !important;\n  color: white !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 8px 25px rgba(108, 92, 231, 0.3) !important;\n}\n\n/* 禁用状态的下载按钮样式 */\n.btn-download.btn-disabled {\n  background: #f5f5f5 !important;\n  color: #bfbfbf !important;\n  cursor: not-allowed !important;\n  opacity: 0.6;\n}\n\n.btn-download.btn-disabled:hover {\n  background: #f5f5f5 !important;\n  color: #bfbfbf !important;\n  transform: none !important;\n}\n\n/* 游戏描述区域 */\n.game-description-section {\n  padding: 24px;\n}\n\n.description-title {\n  margin: 0 0 24px 0 !important;\n  color: var(--color-text);\n  font-weight: 700;\n  font-size: 18px;\n  display: inline-flex; /* 改为inline-flex，让容器宽度适应内容 */\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #6C5CE7; /* 横线只在icon+文字宽度下方 */\n}\n\n.description-icon {\n  color: var(--color-primary);\n  font-size: 16px; /* 与section-icon保持一致 */\n  /* 移除margin-top，让flex的align-items: center处理垂直居中 */\n}\n\n/* 游戏截图样式 */\n.game-screenshots {\n  margin: 20px 0;\n}\n\n.screenshots-container {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 8px 0;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #ccc transparent;\n}\n\n.screenshots-container::-webkit-scrollbar {\n  height: 6px;\n}\n\n.screenshots-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.screenshots-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 3px;\n}\n\n.screenshots-container::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n.screenshot-item {\n  flex-shrink: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n  position: relative;\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.screenshot-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.screenshot-image {\n  width: 200px;\n  height: 120px;\n  object-fit: cover;\n  display: block;\n  border-radius: 8px;\n}\n\n.screenshot-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  height: 120px;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.screenshots-hint {\n  text-align: center;\n  margin-top: 12px;\n  color: #666;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.screenshots-hint span {\n  background: rgba(108, 92, 231, 0.1);\n  color: var(--color-primary);\n  padding: 4px 12px;\n  border-radius: 12px;\n  display: inline-block;\n}\n\n.no-screenshots {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n  font-size: 14px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  margin: 20px 0;\n}\n\n.no-screenshots span {\n  display: inline-block;\n  padding: 8px 16px;\n  background: #f0f0f0;\n  border-radius: 20px;\n  color: #666;\n}\n\n.description-content {\n  line-height: 1.6;\n  color: #6b7280;\n}\n\n.description-content p {\n  margin-bottom: 12px;\n}\n\n.description-stats {\n  margin-top: 12px !important;\n  color: #6b7280;\n}\n\n.description-content h1,\n.description-content h2,\n.description-content h3,\n.description-content h4,\n.description-content h5,\n.description-content h6 {\n  color: var(--color-text);\n  margin-top: 24px;\n  margin-bottom: 12px;\n}\n\n/* h5标签特定样式 */\n.description-content h5 {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.description-content p {\n  margin-bottom: 12px;\n}\n\n.description-content ul,\n.description-content ol {\n  margin-bottom: 12px;\n  padding-left: 24px;\n}\n\n.description-content li {\n  margin-bottom: 4px;\n}\n\n.description-content strong {\n  color: var(--color-text);\n  font-weight: 600;\n}\n\n.description-content code {\n  background: #f5f5f5;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n}\n\n/* 更多游戏区域 */\n.more-games-section {\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius-lg);\n  padding: 32px;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 32px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.section-title {\n  margin: 0 !important;\n  color: var(--color-text);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.section-icon {\n  color: var(--color-primary);\n  font-size: 16px;\n  margin-right: 8px;\n}\n\n.section-more {\n  color: var(--color-primary);\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transition: var(--transition);\n}\n\n.section-more:hover {\n  color: var(--color-secondary);\n  transform: translateX(2px);\n}\n\n.games-grid {\n  margin-bottom: 24px;\n}\n\n.game-card {\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius);\n  border: 1px solid #f0f0f0;\n  overflow: hidden;\n  cursor: pointer;\n  transition: var(--transition);\n  height: 100%;\n}\n\n.game-card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: rgba(108, 92, 231, 0.2);\n}\n\n.game-card-image {\n  padding: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  aspect-ratio: 1;\n}\n\n.game-card-img {\n  width: 100%;\n  aspect-ratio: 1;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n}\n\n.game-card-info {\n  padding: 0 12px 12px 12px;\n}\n\n.game-card-title {\n  margin: 0 0 8px 0 !important;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text);\n  line-height: 1.3;\n}\n\n.game-card-rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.game-card-rating .ant-rate {\n  font-size: 10px !important;\n  color: #faad14 !important;\n}\n\n.rating-text {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.random-play-section {\n  text-align: center;\n  padding-top: 24px;\n}\n\n.btn-random-play {\n  background: var(--color-primary) !important;\n  border: none !important;\n  border-radius: 9999px !important;\n  height: 48px !important;\n  padding: 0 32px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: white !important;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 8px;\n}\n\n.btn-random-play:hover {\n  background: rgba(108, 92, 231, 0.9) !important;\n  color: white !important;\n  transform: translateY(-1px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n/* 评分弹窗样式 */\n.rating-modal .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.rating-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.rating-modal-header .close-btn {\n  border: none;\n  box-shadow: none;\n  color: #999;\n}\n\n.rating-modal-header .close-btn:hover {\n  color: #666;\n}\n\n.rating-modal-content {\n  text-align: center;\n}\n\n.game-info-modal {\n  margin-bottom: 24px;\n}\n\n.game-logo-modal {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n\n.game-title-modal {\n  margin: 0 !important;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.rating-stars-modal {\n  margin-bottom: 24px;\n}\n\n.rating-stars-large .ant-rate {\n  font-size: 32px !important;\n  color: #faad14 !important;\n}\n\n.review-input {\n  margin-bottom: 24px;\n}\n\n.review-input .ant-input {\n  border-radius: 8px;\n  border: 1px solid #d9d9d9;\n  resize: none;\n}\n\n.review-input .ant-input:focus {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);\n}\n\n.submit-rating-btn {\n  width: 100%;\n  height: 48px;\n  border-radius: 8px;\n  font-weight: 500;\n  background: var(--color-primary) !important;\n  border: none !important;\n}\n\n.submit-rating-btn:hover {\n  background: rgba(108, 92, 231, 0.9) !important;\n}\n\n.submit-rating-btn:disabled {\n  background: #f5f5f5 !important;\n  color: #bfbfbf !important;\n}\n\n/* 分享弹窗样式 */\n.share-modal .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.share-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.share-modal-header .close-btn {\n  border: none;\n  box-shadow: none;\n  color: #999;\n}\n\n.share-modal-header .close-btn:hover {\n  color: #666;\n}\n\n.share-modal-content {\n  text-align: center;\n  padding: 8px;\n  min-width: 200px;\n}\n\n.share-description {\n  margin-bottom: 24px;\n  color: #666;\n  font-size: 14px;\n}\n\n.share-platforms {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.share-platform {\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.share-platform:hover {\n  transform: scale(1.1);\n}\n\n.share-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.share-icon.weibo {\n  background: #E6162D;\n}\n\n.share-icon.qq {\n  background: #12B7F5;\n}\n\n.share-icon.wechat {\n  background: #0F88EB;\n}\n\n.share-icon.zhihu {\n  background: #0066FF;\n}\n\n.share-icon.twitter {\n  background: #1DA1F2;\n}\n\n.share-icon.facebook {\n  background: #4267B2;\n}\n\n.share-icon.youtube {\n  background: #FF0000;\n}\n\n.share-icon.link {\n  background: #f5f5f5;\n  color: #666;\n}\n\n.share-link-section {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.share-link-input {\n  flex: 1;\n  border-radius: 8px;\n}\n\n.copy-link-btn {\n  border-radius: 8px;\n  background: var(--color-primary) !important;\n  border: none !important;\n}\n\n.copy-link-btn:hover {\n  background: rgba(108, 92, 231, 0.9) !important;\n}\n\n.sidebar {\n  position: sticky;\n  top: 88px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sidebar-card {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-card .ant-card-head-title {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.categories-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.category-item {\n  cursor: pointer;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  margin: 0;\n}\n\n.category-item:hover {\n  background: #1890ff;\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.sidebar-app-item {\n  cursor: pointer;\n  padding: 12px 0;\n  border-bottom: 1px solid #f0f0f0;\n  transition: all 0.3s ease;\n  border-radius: 8px;\n  margin: 0 -8px;\n  padding: 12px 8px;\n}\n\n.sidebar-app-item:last-child {\n  border-bottom: none;\n}\n\n.sidebar-app-item:hover {\n  background: #f9f9f9;\n  transform: translateX(4px);\n}\n\n.sidebar-app-name {\n  color: #262626;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.sidebar-app-category {\n  font-size: 12px;\n}\n\n@media (max-width: 992px) {\n  .sidebar {\n    position: static;\n    margin-top: 24px;\n  }\n  \n  .sidebar-card {\n    margin-bottom: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  /* 修复移动端滚动问题 - 覆盖全局的overflow设置 */\n  body {\n    overflow: auto !important; /* 允许页面滚动 */\n  }\n\n  .App {\n    height: auto !important; /* 移除固定高度 */\n    overflow: auto !important; /* 允许滚动 */\n  }\n\n  .app-detail-layout {\n    min-height: auto; /* 移除固定高度限制 */\n    height: auto; /* 确保高度自适应内容 */\n  }\n\n  .app-detail-content {\n    min-height: auto; /* 移除固定高度限制 */\n    padding: 16px 0; /* 减少padding */\n  }\n\n  .content-container.app-detail-container {\n    padding: 0 16px;\n  }\n\n  .game-info-row {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    padding: 20px;\n  }\n\n  .game-info-content {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    text-align: center;\n  }\n\n  .game-logo {\n    width: 120px;\n    height: 120px;\n  }\n\n  .game-title-section {\n    padding: 20px 20px 12px 20px;\n  }\n\n  .game-title-section .game-title {\n    font-size: 20px;\n  }\n\n  .game-tags {\n    justify-content: center;\n  }\n\n  .game-rating-info {\n    justify-content: center;\n  }\n\n  .game-rating {\n    justify-content: center;\n  }\n\n  .game-actions {\n    justify-content: center;\n  }\n\n  .game-info-right {\n    align-items: center;\n  }\n\n  .btn-download {\n    min-width: 140px;\n  }\n\n  .more-games-section {\n    padding: 20px;\n  }\n\n  .section-title {\n    font-size: 16px;\n  }\n\n  .description-title {\n    font-size: 16px; /* 移动端字号调整 */\n  }\n\n  .game-screenshots {\n    margin: 16px 0;\n  }\n\n  .screenshots-container {\n    gap: 8px;\n    padding: 4px 0;\n  }\n\n  .screenshot-image {\n    width: 160px;\n    height: 96px;\n  }\n\n  .screenshot-loading {\n    width: 160px;\n    height: 96px;\n  }\n\n  .screenshots-hint {\n    margin-top: 8px;\n    font-size: 11px;\n  }\n\n  .screenshots-hint span {\n    padding: 3px 8px;\n  }\n\n  .no-screenshots {\n    padding: 30px 16px;\n    margin: 16px 0;\n  }\n\n  .no-screenshots span {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n\n  .game-card-title {\n    font-size: 12px;\n  }\n\n  .btn-random-play {\n    height: 44px !important;\n    font-size: 14px !important;\n    padding: 0 24px !important;\n  }\n\n  .share-platforms {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px;\n  }\n\n  .share-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n\n  /* 移动端截图预览Modal样式 */\n  .screenshot-preview-modal {\n    margin: 16px;\n    width: calc(100% - 32px) !important;\n    max-width: none !important;\n  }\n\n  .screenshot-preview-image-container {\n    min-height: 300px;\n  }\n\n  .screenshot-preview-header {\n    top: 12px;\n    right: 12px;\n  }\n\n  .screenshot-close-btn {\n    width: 36px !important;\n    height: 36px !important;\n  }\n\n  .screenshot-navigation {\n    bottom: 16px;\n    gap: 12px;\n    padding: 6px 12px;\n  }\n\n  .screenshot-nav-btn {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .screenshot-counter {\n    font-size: 12px;\n    min-width: 36px;\n  }\n}\n\n@media (max-width: 480px) {\n  /* 修复移动端滚动问题 - 覆盖全局的overflow设置 */\n  body {\n    overflow: auto !important; /* 允许页面滚动 */\n  }\n\n  .App {\n    height: auto !important; /* 移除固定高度 */\n    overflow: auto !important; /* 允许滚动 */\n  }\n\n  .app-detail-layout {\n    min-height: auto; /* 移除固定高度限制 */\n    height: auto; /* 确保高度自适应内容 */\n  }\n\n  .app-detail-content {\n    min-height: auto; /* 移除固定高度限制 */\n    padding: 12px 0; /* 进一步减少padding */\n  }\n\n  .content-container.app-detail-container {\n    padding: 0 12px;\n  }\n\n  .game-info-row {\n    padding: 16px;\n  }\n\n  .game-logo {\n    width: 100px;\n    height: 100px;\n  }\n\n  .game-title-section {\n    padding: 16px 16px 10px 16px;\n  }\n\n  .game-title-section .game-title {\n    font-size: 18px;\n  }\n\n  .game-screenshots {\n    margin: 12px 0;\n  }\n\n  .screenshots-container {\n    gap: 6px;\n  }\n\n  .screenshot-image {\n    width: 140px;\n    height: 84px;\n  }\n\n  .screenshot-loading {\n    width: 140px;\n    height: 84px;\n  }\n\n  .screenshots-hint {\n    margin-top: 6px;\n    font-size: 10px;\n  }\n\n  .screenshots-hint span {\n    padding: 2px 6px;\n  }\n\n  .no-screenshots {\n    padding: 24px 12px;\n    margin: 12px 0;\n  }\n\n  .no-screenshots span {\n    padding: 4px 8px;\n    font-size: 12px;\n  }\n\n  .game-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .btn-rating,\n  .btn-share {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .game-info-right {\n    gap: 8px;\n  }\n\n  .btn-download {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .more-games-section {\n    padding: 16px;\n  }\n\n  .game-card-title {\n    font-size: 11px;\n  }\n\n  .share-platforms {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 8px;\n  }\n\n  .share-icon {\n    width: 36px;\n    height: 36px;\n    font-size: 14px;\n  }\n\n  /* 小屏幕截图预览Modal样式 */\n  .screenshot-preview-modal {\n    margin: 8px;\n    width: calc(100% - 16px) !important;\n    max-width: none !important;\n  }\n\n  .screenshot-preview-image-container {\n    min-height: 200px;\n  }\n\n  .screenshot-preview-header {\n    top: 6px;\n    right: 6px;\n  }\n\n  .screenshot-close-btn {\n    width: 28px !important;\n    height: 28px !important;\n  }\n\n  .screenshot-navigation {\n    bottom: 12px;\n    gap: 8px;\n    padding: 4px 8px;\n  }\n\n  .screenshot-nav-btn {\n    width: 28px !important;\n    height: 28px !important;\n  }\n\n  .screenshot-counter {\n    font-size: 11px;\n    min-width: 32px;\n  }\n}\n\n/* 截图预览Modal样式 */\n.screenshot-preview-modal .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n  padding: 0;\n}\n\n.screenshot-preview-content {\n  position: relative;\n}\n\n.screenshot-preview-header {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 10;\n}\n\n.screenshot-close-btn {\n  background: rgba(0, 0, 0, 0.6) !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 50% !important;\n  width: 40px !important;\n  height: 40px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  transition: all 0.3s ease !important;\n}\n\n.screenshot-close-btn:hover {\n  background: rgba(0, 0, 0, 0.8) !important;\n  transform: scale(1.1);\n}\n\n.screenshot-preview-image-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  min-height: 400px;\n}\n\n.screenshot-navigation {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  z-index: 10;\n  background: rgba(0, 0, 0, 0.6);\n  padding: 8px 16px;\n  border-radius: 20px;\n}\n\n.screenshot-nav-btn {\n  background: rgba(255, 255, 255, 0.2) !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 50% !important;\n  width: 36px !important;\n  height: 36px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  transition: all 0.3s ease !important;\n}\n\n.screenshot-nav-btn:hover {\n  background: rgba(255, 255, 255, 0.3) !important;\n  transform: scale(1.1);\n}\n\n.screenshot-nav-btn:disabled {\n  background: rgba(255, 255, 255, 0.1) !important;\n  color: rgba(255, 255, 255, 0.5) !important;\n  cursor: not-allowed !important;\n}\n\n.screenshot-nav-btn:disabled:hover {\n  transform: none !important;\n}\n\n.screenshot-counter {\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  min-width: 40px;\n  text-align: center;\n}\n\n.screenshot-preview-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  max-height: 80vh;\n  object-fit: contain;\n}\n\n.screenshot-preview-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #999;\n  font-size: 16px;\n  background: #f5f5f5;\n  border-radius: 8px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
